(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kozler-icon-mega-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const triggerBtn = document.querySelector('.new-mega-menu__button-btn');
  const shadow = document.getElementById('newMegaDrawerShadow');
  const drawer = document.getElementById('newMegaDrawer');
  const content = document.getElementById('newMegaDrawerContent');
  const header = document.getElementById('newMegaDrawerHeader');

  if (triggerBtn) triggerBtn.addEventListener('click', showNewMegaDrawer);
  if (shadow) shadow.addEventListener('click', hideNewMegaDrawer);

  // Drawer nav state
  let currentLevel = 'primary';
  let previousTitleStack = [];

  function showMenu(level, parentTitle = null, isBack = false) {
    const currentActive = document.querySelector('.new-mega-drawer-list.active-item');
    if (currentActive) {
      currentActive.classList.remove('active-item');
      currentActive.style.transform = isBack ? 'translateX(100%)' : 'translateX(-100%)';
    }

    const next = level === 'primary'
      ? document.querySelector('.new-mega-drawer-list--primary')
      : document.querySelector(`.new-mega-drawer-list--${level}[data-parent="${parentTitle}"]`);

    if (!next) return;

    next.style.transform = 'translateX(100%)';
    requestAnimationFrame(() => {
      next.classList.add('active-item');
      next.style.transform = 'translateX(0)';
    });

    if (level === 'primary') previousTitleStack = [];
    else if (!isBack) previousTitleStack.push(parentTitle);

    currentLevel = level;
  }

  showMenu('primary');

  // Forward nav
  document.querySelectorAll('.new-mega-drawer-item-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const hasChildren = link.parentNode.getAttribute('data-has-children') === 'true';
      if (hasChildren) {
        e.preventDefault();
        const parentTitle = link.getAttribute('data-title');
        const nextLevel = currentLevel === 'primary' ? 'child' : 'grandchild';
        showMenu(nextLevel, parentTitle, false);
      }
    });
  });

  // Back buttons
  document.querySelectorAll('.new-mega-drawer-back .back-to-primary').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showMenu('primary', null, true);
    });
  });

  document.querySelectorAll('.new-mega-drawer-back .back-to-child').forEach(function (btn) {
    btn.addEventListener('click', function () {
      previousTitleStack.pop();
      const parentTitle = previousTitleStack[previousTitleStack.length - 1];
      showMenu('child', parentTitle, true);
    });
  });

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideNewMegaDrawer();
  });

  // Resize behavior
  window.addEventListener('resize', adjustNewMegaDrawerSize);
});

let isNewMegaDrawerOpen = false;

function showNewMegaDrawer() {
  const drawer = document.getElementById('newMegaDrawer');
  const shadow = document.getElementById('newMegaDrawerShadow');
  const content = document.getElementById('newMegaDrawerContent');
  const header = document.getElementById('newMegaDrawerHeader');

  if (!drawer || !shadow || !content) return;

  // Mark open FIRST so adjustNewMegaDrawerSize runs properly
  isNewMegaDrawerOpen = true;
  adjustNewMegaDrawerSize();

  // Animate in
  drawer.style.transition = 'width 0.3s ease';
  drawer.style.width = '424px';

  shadow.style.visibility = 'visible';
  shadow.style.opacity = '1';
  shadow.style.pointerEvents = 'auto';

  setTimeout(() => {
    content.style.opacity = '1';
    if (header) header.style.position = 'fixed';
  }, 300);
}

function hideNewMegaDrawer() {
  const drawer = document.getElementById('newMegaDrawer');
  const shadow = document.getElementById('newMegaDrawerShadow');
  const content = document.getElementById('newMegaDrawerContent');
  const header = document.getElementById('newMegaDrawerHeader');

  if (!drawer || !shadow || !content) return;

  content.style.opacity = '0';
  shadow.style.pointerEvents = 'none';
  shadow.style.opacity = '0';
  shadow.style.visibility = 'hidden';

  drawer.style.transition = 'width 0.3s ease';
  drawer.style.width = '0';

  setTimeout(() => {
    if (header) header.style.position = 'relative';
    isNewMegaDrawerOpen = false;
  }, 300);
}

function adjustNewMegaDrawerSize() {
  const drawer = document.getElementById('newMegaDrawer');
  if (!drawer || !isNewMegaDrawerOpen) return;

  if (window.innerWidth <= 749) {
    drawer.style.height = 'calc(100% - 12px)';
    drawer.style.width = '424px';
  } else {
    drawer.style.width = '424px';
    drawer.style.height = 'calc(100% - 12px)';
  }
}

window.showNewMegaDrawer = showNewMegaDrawer;
window.hideNewMegaDrawer = hideNewMegaDrawer;


  } catch(e) { console.error(e); }
})();
})();
